<template>
  <div>
    <van-popup
      v-model="showCrop"
      round
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      class="popup-width"
    >
      <div class="corp-popup">
        <ld-header @click-left="showCrop = false">
          企业选择
          <div class="font12 gray">
            (检测到您注册了多个企业)
          </div>
        </ld-header>
        <van-radio-group v-model="corpId">
          <van-cell-group :border="false">
            <div
              v-for="item in compList"
              :key="item.companyId"
            >
              <van-cell>
                <div class="font16 font-bold">
                  {{ item.companyName }}(服务商)
                </div>
              </van-cell>
              <div style="padding-left:30px;">
                <van-cell
                  v-for="corp in item.vipCorpList"
                  :key="corp.corpId"
                  :title="corp.shortname"
                  clickable
                  @click="corpChecked(item.companyId,corp.corpId)"
                >
                  <template #right-icon>
                    <van-radio :name="corp.corpId" />
                  </template>
                </van-cell>
              </div>
            </div>
          </van-cell-group>
        </van-radio-group>
        <van-cell :border="false">
          <van-checkbox
            v-model="remember"
            icon-size="16px"
          >
            <span class="gray">下次默认以此身份登录</span>
          </van-checkbox>
        </van-cell>
        <van-cell>
          <ld-button
            @click.native="hideCorp"
            main2
            :disabled="!corpId"
            size="lg"
          >
            {{ btnText }}
          </ld-button>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Field, Popup, Checkbox ,RadioGroup, Radio,CellGroup,Cell} from 'vant'

import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'

export default {
  components: {
    ldButton,
    [Field.name]:Field,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [Checkbox.name]:Checkbox,
    [Popup.name]:Popup,
  },
  props:{
    compList:{
      type:Array,
      default:function(){
        return []
      }
    },
    btnText:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      showCrop:false,
      corpId:'',
      compId:'',
      remember:false,
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    toggle(){
      this.showCrop=!this.showCrop
    },
    // 选中企业
    corpChecked(compId,corpId){
      this.compId = compId
      this.corpId = corpId
    },
    //关闭企业选择框
    hideCorp(){
      this.$emit('selected',this.compId,this.corpId,this.remember)
      this.showCrop=false
    },
  },
  computed: {
    ...mapGetters(['loginConfig'])
  }
}
</script>

<style lang="less" scoped>
    .corp-popup{
        padding: 20px 0;
    }
</style>
